module.exports = __webpack_public_path__ + "static/media/crater-lake.d4736d5b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/crater-lake.png
 ** module id = 191
 ** module chunks = 0
 **/